import { Offerte } from "../model/offerte";
import { Soglie } from "../model/soglie";

export class irenwebDual {
  public static  offerta ():Offerte {
      return {
		Flg_Indicizzato: false,
        Id_Offerta: 118,
        Id_Foritore: 1,
        Id_comodity: 3,
        TipoContratto:1,
        NomeOfferta: "IREN WEB DUAL",
        LinkFoto: "./assets/images/offerte-iren/web-dual.jpg",
        LinkFotoLarge: "./assets/images/offerte-iren/web-dual.jpg",
        LinkFotoMid: "./assets/images/offerte-iren/web-dual.jpg",
        LinkFotoSm: "./assets/images/offerte-iren/web-dual.jpg",
        LinkFotoCarousel: "./assets/images/offerte-iren/web-dual.jpg",
        DescrizioneCarousel: "Che Offerta super",
        DescrizioneNomeOfferta: "Iren luce gas e servizi, propone un’offerta luce e/o gas studiata in base ai bisogni delle famiglie e delle piccole aziende. ",
        PromozioneOfferta: "",
        Sezioni: [
          {
            NomeSezione: "RISPARMIO ASSICURATO",
            DescrizioneSezione: "Per risparmiare sulle bollette di luce e gas, la soluzione migliore è quella di acquisire comportamenti che limitino il consumo. Sappiamo che gli sprechi di energia elettrica e gas in casa sono comuni ed è faticoso far cambiare abitudini a tutta la famiglia. Per questo motivo scegliere una offerta di luce e gas conveniente è la soluzione che può portare a concreti risparmi in bolletta.",
            lstPunti: []
          },
          {
            NomeSezione: "",
            DescrizioneSezione: "Le offerte IREN ENERGIA WEB E IREN GAS WEB bloccano il prezzo della componente energia per 1 anno e ti aiutano a tenere sotto controllo le bollette di gas e luce. Per l’energia elettrica, l’offerta prevede l’applicazione di un prezzo monorario, fisso e invariabile pari a 0,0545 €/kWh; per i contratti gas, invece, il prezzo del gas al metro cubo è pari a 0,210 €. Scegliere Iren luce gas e servizi conviene!",
            lstPunti: [
            ]

          },
          {
            NomeSezione: "",
            DescrizioneSezione: "IREN Web: la comodità del web e un prezzo bloccato per un anno.",
            lstPunti: [
            ]

          }
        ],
        PrezzoEle: 0.0689,
        PrezzoGas: 0.279,
       
        TitoloPlus: "Vantaggi assicurati",
        Plus: ["Prezzo bloccato per 1 anno", "Nessuna spesa di passaggio al mercato libero",
        "Nessun costo aggiuntivo"]
        , schedaconfrontabilitaele: {
          tabellaConfrontabilita: [
            { consumoannuo: 1500, tipoprofilo: 1, Residente: 1, potenza: 3, importo: 277.80 },
            { consumoannuo: 2200, tipoprofilo: 1, Residente: 1, potenza: 3, importo: 367.97 },
            { consumoannuo: 2700, tipoprofilo: 1, Residente: 1, potenza: 3, importo: 440.74 },
            { consumoannuo: 3200, tipoprofilo: 1, Residente: 1, potenza: 3, importo: 513.51 },
            { consumoannuo: 1500, tipoprofilo: 2, Residente: 1, potenza: 3, importo: 277.80 },
            { consumoannuo: 2200, tipoprofilo: 2, Residente: 1, potenza: 3, importo: 367.97 },
            { consumoannuo: 2700, tipoprofilo: 2, Residente: 1, potenza: 3, importo: 440.74 },
            { consumoannuo: 3200, tipoprofilo: 2, Residente: 1, potenza: 3, importo: 513.51 },
            { consumoannuo: 1500, tipoprofilo: 3, Residente: 1, potenza: 3, importo: 277.80 },
            { consumoannuo: 2200, tipoprofilo: 3, Residente: 1, potenza: 3, importo: 367.97 },
            { consumoannuo: 2700, tipoprofilo: 3, Residente: 1, potenza: 3, importo: 440.74 },
            { consumoannuo: 3200, tipoprofilo: 3, Residente: 1, potenza: 3, importo: 513.54 },
  
            
            { consumoannuo: 900, tipoprofilo: 1, Residente: 2, potenza: 3, importo: 346.90 },
            { consumoannuo: 4000, tipoprofilo: 1, Residente: 2, potenza: 3, importo: 746.14 },
            { consumoannuo: 900, tipoprofilo:2, Residente: 2, potenza: 3, importo: 346.90},
            { consumoannuo: 4000, tipoprofilo: 2, Residente: 2, potenza: 3, importo: 746.14 },
            { consumoannuo: 900, tipoprofilo: 3, Residente: 2, potenza: 3, importo: 346.90 },
            { consumoannuo: 4000, tipoprofilo: 3, Residente: 2, potenza: 3, importo: 746.14 },
  
            { consumoannuo: 3500, tipoprofilo: 1, Residente: 1, potenza: 4.5, importo: 589.11 },
            { consumoannuo: 3500, tipoprofilo: 2, Residente: 1, potenza: 4.5, importo: 589.11 },
            { consumoannuo: 3500, tipoprofilo: 3, Residente: 1, potenza: 4.5, importo: 589.11 },
  
            { consumoannuo: 3500, tipoprofilo: 1, Residente: 2, potenza: 4.5, importo: 589.11 },
            { consumoannuo: 3500, tipoprofilo: 2, Residente: 2, potenza: 4.5, importo: 589.11 },
            { consumoannuo: 3500, tipoprofilo: 3, Residente: 2, potenza: 4.5, importo: 589.11 }
  
          ]
        }




        ,schedaconfrontabilitagas:  { tabellaConfrontabilita:[ { zona:1, consumoannuo:120,importo:128.22},{ zona:1, consumoannuo:480,importo:276.61},{ zona:1, consumoannuo:70,importo:362.25},{ zona:1, consumoannuo:1400,importo:634.73},{ zona:1, consumoannuo:2000,importo:866.49},{ zona:1, consumoannuo:5000,importo:2022.02} ,{ zona:2, consumoannuo:120,importo:118.47},{ zona:2, consumoannuo:480,importo:257.84},{ zona:2, consumoannuo:70,importo:338.30},{ zona:2, consumoannuo:1400,importo:594.33},{ zona:2, consumoannuo:2000,importo:811.95},{ zona:2, consumoannuo:5000,importo:1896.76} ,{ zona:3, consumoannuo:120,importo:124.70},{ zona:3, consumoannuo:480,importo:275.41},{ zona:3, consumoannuo:70,importo:362.34},{ zona:3, consumoannuo:1400,importo:638.93},{ zona:3, consumoannuo:2000,importo:874.22},{ zona:3, consumoannuo:5000,importo:2047.43} ,{ zona:4, consumoannuo:120,importo:120.13},{ zona:4, consumoannuo:480,importo:278.92},{ zona:4, consumoannuo:70,importo:370.32},{ zona:4, consumoannuo:1400,importo:661.14},{ zona:4, consumoannuo:2000,importo:908.68},{ zona:4, consumoannuo:5000,importo:2143.20} ,{ zona:5, consumoannuo:120,importo:132.99},{ zona:5, consumoannuo:480,importo:301.95},{ zona:5, consumoannuo:70,importo:398.99},{ zona:5, consumoannuo:1400,importo:707.78},{ zona:5, consumoannuo:2000,importo:970.77},{ zona:5, consumoannuo:5000,importo:2282.63} ,{ zona:6, consumoannuo:120,importo:140.13},{ zona:6, consumoannuo:480,importo:327.17},{ zona:6, consumoannuo:70,importo:434.28},{ zona:6, consumoannuo:1400,importo:775.05},{ zona:6, consumoannuo:2000,importo:1065.55},{ zona:5, consumoannuo:5000,importo:2515.12}]}
      
        ,lstModalitaPagamento :["2"]
        ,scontoRid:0 
        ,TipoSoglieEle: Soglie.SoglieEle4Fasce()
        ,ImportoAnnuoLordo: 0
        ,ImportoAnnuoNetto: 0
        ,ImportoMensileLordo: 0
        ,ImportoMensileNetto: 0
        ,iscopertura: "" 
      };
    }
}



// WEBPACK FOOTER //
// ./src/app/archivioofferte/irenwebDual.ts